import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { EnvironmentService } from "./environment.service";
import { map } from "rxjs/operators";
import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class HomeGuard  {
  constructor(
    public environmentService: EnvironmentService,
    private router: Router,
    private userService: UserService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const result = new BehaviorSubject(true);

    this.environmentService
      .getInstanceDetails()
      .pipe(
        map((details: any) => {
          // logic throughout to navigate users to the /home page, but that differs from product to product what that endpoint is or if the user has access to that page at all
          if (/ai-detection/.test(details?.scaffoldType)) {
            this.userService['_roleInformation']?.view_admin? this.router.navigate(["/ai-detection-report"]):this.router.navigate(["/courses"])
          }
          if (/archivev2/.test(details?.scaffoldType)&&!details?.no_self_serve) {     
            this.userService['_roleInformation']?.view_admin? this.router.navigate(["/imports"]):this.router.navigate(["/courses"])
          }
          // if (/migration/.test(details?.scaffoldType)) {     
          //   this.userService['_roleInformation']?.view_admin? this.router.navigate(["/migration"]):this.router.navigate(["/courses"])
          // }
          result.next(true);
        })
      )
      .subscribe();
    return result;
  }
}
